import React from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "./AlertPop.module.scss";

const AlertPop = ({
  confirmation,
  setConfirmation,
  message,
  buttonText
}) => {
  const hideHandler = () => {
    setConfirmation(false);
  };
  return (
    <>
      <Modal
        show={confirmation}
        className={`${styles.ConfirmationPop} transparentModal common-alert-modal`}
        onHide={hideHandler}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className={`${styles.modalBody}`}>
          <div className="px-md-5 text-center mx-auto">
            <h3 className={`${styles.modalMessage} m-0 fw-bold themeBlue`}>{message}</h3>
            <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
              <div className="px-2">
                <Button
                  onClick={hideHandler}
                  className={`${styles.modalButton} fw-sbold d-flex align-items-center justify-content-center commonBtn w-100`}
                >
                  Ok
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AlertPop;
